<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.stop="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>编辑用户角色</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.stop="save" :loading="loading" :disabled="loading">
          <span class="text-h6">保存</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row class="text-body-1 black--text">
          <v-col cols="12" sm="6">
            用户名：{{userData.username}}
          </v-col>
          <v-col cols="12" sm="6">
            昵称：{{userData.nickname}}
          </v-col>
          <v-col cols="12" sm="6">
            邮箱：{{userData.email}}
          </v-col>
          <v-col cols="12" sm="6">
            电话：{{userData.phone}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-body-1 black--text">
            请选择角色：
            <v-switch
              v-for="r in roleList"
              :key="r.id"
              hide-details
              v-model="selected"
              :label="`${r.name}（${r.code}）`"
              :value="r.id"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'

export default {
  name: 'EditUserDialog',
  props: {
    status: Boolean,
    userData: Object
  },
  data () {
    return {
      loading: false,
      selected: []
    }
  },
  computed: {
    roleList () {
      return this.$store.state.roles
    }
  },
  created () {
    this.selectRole(this.userData)
  },
  methods: {
    selectRole (arg) {
      this.selected = arg.roles ? arg.roles.map(r => r.id) : []
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.loading = true
      const payload = {
        userId: this.userData.id,
        roleSet: this.selected
      }
      const request = buildAxios()
      request.post('user/modifyRoles', payload)
        .then(res => {
          this.$emit('save', res.data.data)
          this.loading = false
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
          this.loading = false
        })
    }
  },
  watch: {
    status () {
      this.selectRole(this.userData)
    }
  }
}
</script>
